export const copyText = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else if (window.getSelection) {
    const textEl = document.createElement('span');
    const content = document.createTextNode(text);
    textEl.appendChild(content);
    textEl.style.position = 'absolute';
    textEl.style.top = '-100%';
    textEl.style.left = '-100%';
    document.body.appendChild(textEl);
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(textEl);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    document.body.removeChild(textEl);
  }
};
